import _ from 'lodash';

import { GET_CATEGORIES, DELETE_ITEM, UPDATE_ITEM } from 'admin/constants';

export const initialState = {
	fetching: false,
	data: {},
};

export default function categoriesReducer(state = initialState, action) {
	if ([GET_CATEGORIES.START].some(o => o === action.type)) {
		return { ...state, fetching: true };
	}

	if ([GET_CATEGORIES.FAIL].some(o => o === action.type)) {
		return { ...state, fetching: false };
	}

	if (action.type === GET_CATEGORIES.SUCCESS) {
		return { data: { ...action.payload }, fetching: false };
	}

	if (action.type === DELETE_ITEM.SUCCESS || action.type === UPDATE_ITEM.SUCCESS) {
		const data = _.reduce(
			state.data,
			(acc, category) => {
				acc[category.id] = {
					...category,
					items: _.filter(category.items, itemId => itemId !== action.payload.id),
				};
				return acc;
			},
			{}
		);

		if (action.type === UPDATE_ITEM.SUCCESS) {
			data[action.payload.categoryId].items.push(action.payload.id);
		}

		return { data, fetching: false };
	}

	return state;
}
